<script>

    import { toast } from 'bulma-toast'
    import { tipsStore, modalStore, adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import TipsService from '../$services/tips.service'

    import Table from '../$components/table.svelte'
    import ButtonOpen from '../$components/button.open.svelte'
    import Button from '../$components/button.svelte'

    let loading = false

    getTips()

    async function getTips() {

        loading = true
        const resp = await TipsService.getTips()
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        tipsStore.set(resp.data)
    }

</script>

<Table items={ $tipsStore.length } { loading } skeletonCols={4}>
    <div slot="header" class="header-filters">
        {#if isPermission($adminStore, 'SettingsView.Tip.Create')}
            <div class="header-top">
                <Button text="Agregar" icon="plus" on:click={() => modalStore.open('tip_create_modal')} />
            </div>
        {/if}
    </div>
    <thead slot="thead">
        <tr>
            <th>#</th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-tag"></i></span>
                    <span>Tipo</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-comment"></i></span>
                    <span>Mensaje</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-ellipsis-v"></i></span>
                    <span>Acciones</span>
                </span>
            </th>
        </tr>
    </thead>
    <tbody slot="tbody">
        {#each $tipsStore as tip, index}
            <tr>
                <td>{ index + 1 }</td>
                <td>{ tip.type }</td>
                <td>{ tip.message }</td>
                <td>
                    <ButtonOpen on:click={() => modalStore.open('tip', 'modal', tip)} />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>
